module.exports = __webpack_public_path__ + "media/images/result_sets/circles/7n6n5r1n-0aa5d87d2f9fa4006377f8e764f66bdd.svg";